import { Endpoints } from "services/api";
import { ApiError, ErrorResponse, getFetch } from "@wexinc/wex-common-web";
import { CreateLocalInvitationUser, InvitationLoginMethods } from ".";

const apiRoot = "invitation-acceptance";

const { get, post } = getFetch(Endpoints.apiRoot);

function getInvitationLoginMethods(invitationId: number, invitationToken: string): Promise<InvitationLoginMethods> {
  return get({
    relativeRoute: `${apiRoot}/${invitationId}/login-methods`,
    customAccessToken: invitationToken,
    responseErrorHandler: async (response) => {
      const errorMessage = (await response.json()) as ErrorResponse;
      return Promise.reject(new ApiError(errorMessage));
    },
  });
}

function createLocalUser(
  invitationId: number,
  invitationToken: string,
  data: CreateLocalInvitationUser,
): Promise<void> {
  return post({
    relativeRoute: `${apiRoot}/${invitationId}/local-user`,
    customAccessToken: invitationToken,
    body: data,
  });
}

export { getInvitationLoginMethods, createLocalUser };
